import React, { useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import { api_crud_base, api_crud_route, api_list_route, endpoints } from './Config';

import { reqGET, reqDELETE, translate } from '../../../Utils';
import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';
import { useRef } from "react";
import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

export default function List(props) {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);
    const [data, setData] = useState([])
    const [categorias, set_categorias] = useState([])
    const [tipos, set_tipos] = useState([])
    const [natureza, set_natureza] = useState([])
    const [isloading, setLoading] = useState(true)

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation();

    useEffect(() => {
        // console.log('AQUI NA LISTA')

        let fetchApi = async () => {
            set_lang(localStorage.getItem('lang'))

            let res_1 = await reqGET(`${api_crud_base}/entities/attributes/type/${getTokenInfo().companycode}/entity_category`)
            let res_2 = await reqGET(`${api_crud_base}/entities/attributes/type/${getTokenInfo().companycode}/entity_type`)
            let res_3 = await reqGET(`${api_crud_base}/entities/attributes/type/${getTokenInfo().companycode}/entity_nature`)
            let res = await reqGET(api_list_route(getTokenInfo().companycode))

            set_categorias(res_1.data)
            set_tipos(res_2.data)
            set_natureza(res_3.data)
            setData(res.data)

            return true
        }

        (async () => {

            await fetchApi()
            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            document.getElementById("row-" + id).remove();
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })

    }

    const get_type_name = (array, id) => {

        if (id !== '') {
            let res = array.filter(e => parseInt(e.id) === parseInt(id))
            if (res.length > 0) {
                return translate(res[0].info.name, 'pt')
            }
            else {
                return ''
            }
        }
        else {
            return ''
        }

    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if(permissions.current !== null) {
                                aux = permissions.current

                                if(aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if(aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if(aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {
                    
                    let aux = {}
                    if(permissions.current !== null) {
                        aux = permissions.current

                        if(aux.create !== true) {
                            aux.create = node.create
                        }
                        if(aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if(aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }
                    
                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if(Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }
    
    useEffect(() => {

        (async () => {

            let res = await reqGET(api_list_route(getTokenInfo().companycode))
            setData(res.data)

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [props]);

    const columns = [
        {
            name: 'Nome',
            selector: 'name',
            cell: row => <div>{row.name}</div>,
            width: '80%',
            sortable: true,
            left: true,
        },        
        {
            name: '',
            right: true,
            width: '20%',
            export: false,
            //print: false,

            cell: row =>
                <span>
                    <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <img alt='visualizar' src={'./img/view.svg'} />
                    </Link>

                    {/*style={{ display: 'none' }}*/}
                    <Link className="button button-update" to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }} style={{ display: '' }} replace>
                        <img alt='editar' src={'./img/editar.svg'} />
                    </Link>

                    <button onClick={() => apagar(row['id'])} className="button btn-delete">
                        <img alt='apagar' src={'./img/eliminar.svg'} />
                    </button>
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: 'Registos por página:',
        rangeSeparatorText: 'de',
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: 'Todos',
    };

    const tableData = {
        columns,
        data,
        filterPlaceholder: 'Procurar'
    };


    return (isloading ?
        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">LOADING</h2>
                <p>LOADING</p>
                <div className="overlay">
                    <div className="overlay__inner">
                        <div className="overlay__content"><span className="spinner"></span></div>
                    </div>
                </div>

            </div>
        </main>

        :

        <main>
            <div className={`dash-cards header`}>
                <h2 className="dash-title">{language[lang].tipo_de_entidade}</h2>
                <p>{language[lang].menus_perfis_entidade}</p>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">

                            <div className="pb-5">
                                <div className="div-table">
                                    {permissions.current !== null && (permissions.current.create) && (
                                        <div className="table-header text-end mb-8">
                                            <Link className="btn btn-sm btn-primary multi-item"
                                                to={{ pathname: endpoints.regist }}
                                                style={{ padding: '0.15rem 1.25rem', borderRadius: '15px', }}
                                            >
                                                <span>{language[lang].add_new}</span>
                                            </Link>
                                        </div>
                                    )}

                                    <div className="table-body">
                                        <DataTableExtensions {...tableData}>

                                            <DataTable
                                                noDataComponent='Sem Registos'
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}